import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppReleaseService } from '../../../services/app-release.service';
import { AppRelease, Platform } from '../../../models/inModels/app-release.model';

@Component({
  selector: 'app-edit-release',
  templateUrl: './edit-release.component.html',
  styleUrls: ['./edit-release.component.css']
})
export class EditReleaseComponent implements OnInit {
  model: AppRelease;
  error: any[] = [];
  loading = false;
  platforms = [
    { id: 1, label: 'Windows' },
    { id: 2, label: 'MacOS' },
    { id: 3, label: 'Linux' }
  ];
  selectedPlatformType: any = null;

  constructor(
    private service: AppReleaseService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.model = {
      Id: 0,
      VersionNumber: '',
      ReleaseNotes: '',
      IsActive: false,
      Platform: 1,
      PublicId: '',
      FileSize: 0,
      FileName: ''
    };
  }

  ngOnInit() {
    const id = +this.route.snapshot.paramMap.get('id');
    if (id) {
      this.loading = true;
      this.service.getRelease(id).subscribe({
        next: (data: AppRelease) => {
          this.model = data;
          this.selectedPlatformType = this.platforms.find(p => p.id === this.model.Platform);
          this.loading = false;
        },
        error: err => {
          this.error = [{ severity: 'error', summary: 'Error', detail: 'Failed to load release.' }];
          this.loading = false;
        }
      });
    }
  }

  save() {
    this.loading = true;
    this.model.Platform = this.selectedPlatformType ? this.selectedPlatformType.id : 1;
    this.service.updateRelease(this.model.Id, this.model).subscribe(
      res => {
        this.loading = false;
        this.goBack();
      },
      err => {
        this.error = [{ severity: 'error', summary: 'Error', detail: 'Update failed.' }];
        this.loading = false;
      }
    );
  }

  goBack() {
    this.router.navigate(['/app-releases']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-release/edit-release/edit-release.component.ts